import { AssetList } from '@goldcast/api/content';
import { getIsDuplicateRecording } from '@goldcast/player-config/src/utils/clipUtils';
import { Clip } from '@goldcast/player-config/src/types/clip-types';

/**
 * Determines whether an asset is a duplicate recording for navigation purposes.
 *
 * A recording is a duplicate when Content Studio's `duplicated_from` linkage is present
 * (see `getIsDuplicateRecording`) or when the backend surfaces the `is_duplicate` flag —
 * the same signal the admin app's video library reads (see `videoLibraryService.ts`).
 */
export const isDuplicateRecordingAsset = (clip?: Clip | AssetList | null): boolean => {
  if (!clip) {
    return false;
  }
  return getIsDuplicateRecording(clip as Clip) || !!(clip as { is_duplicate?: boolean }).is_duplicate;
};
